import PropTypes from 'prop-types';

import useStyles from './OnFieldPopover.styles';

export default function OnFieldPopover(props) {
  const classes = useStyles(props);
  
  return (
    <div className={classes.popOver} data-test={props.show ? 'OnFieldPopover--show' : 'OnFieldPopover'}>
      <div className={classes.arrow} />
      <div className={classes.inner}>
        <div className={classes.contents}>
          <p>{props.children}</p>
        </div>
      </div>
    </div>
  );
}

OnFieldPopover.propTypes = {
  show: PropTypes.bool,
  children: PropTypes.node.isRequired,
};
